import React from 'react'
import styles from './FormWithTitleWrap.module.scss'
import BoxUi from '../BoxUi/BoxUi'
import cn from 'classnames'

interface IFormWrap {
  title: React.ReactNode | string
  icon?: React.ReactNode | string
  children: React.ReactNode | string
  className?: string
}

const FormWithTitleWrap: React.FC<IFormWrap> = ({ children, title, icon, className }) => {
  return (
    <BoxUi className={cn(styles.container, className)}>
      <div className={styles.header}>
        <div className={styles.title}>
          {icon}
          {title}
        </div>
      </div>

      <>
        {children}
      </>
    </BoxUi>
  )
}

export default FormWithTitleWrap